//Popup
window.BUTPopup = window.BUTPopup || class BUTPopup extends BUTCustomComponent {
  static currentZIndex = 100;
  constructor() {
    super();
    this.closeButton = this.$(".js-popup-btn-close");
    this.delayTime = parseInt(this.dataset.delayTime || 0);
    this.popupId = this.dataset.sectionId;
    this.overlay = this.$(".js-dialog-overlay");
    this.container = this.$(".js-popup-container");
    this.enabledOverlay = this.dataset.enabledOverlay;
    this.isAdminEditor = Shopify?.designMode || false;
    this.eleFocusRemove = BUTHelper.qs("a");
    this.init();
  }

  init() {
    this.checkPopupState();
    this.bindEventHandlers();
    if (this.isAdminEditor) this.handlePopupInAdmin();
  }

  getStorageKey() {
    return `BUT_popupDismissedDate_${this.popupId}`;
  }

  bindEventHandlers() {
    this.closeButton?.addEventListener("click", this.handleClose.bind(this));
    this.$(".js-popup-btn-dismiss")?.addEventListener("click", this.handleClose.bind(this));
    this.overlay?.addEventListener("click", this.handleClose.bind(this));
    if (!this.classList.contains("hidden-xs") && this.enabledOverlay == "true")
      this.handleOverlay();
    this.querySelector("form")?.addEventListener("submit", () => {
      if (!this.isAdminEditor) {
        if (this.delayTime > 0) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          localStorage.setItem(this.getStorageKey(), today.toString());
        } else {
          localStorage.setItem(this.getStorageKey(), "permanent");
        }
      }
    });
  }

  checkPopupState() {
    const dismissedDate = localStorage.getItem(this.getStorageKey());
    if (this.isPopupDismissed(dismissedDate)) {
      this.hidePopup();
      return true;
    } else if (dismissedDate !== "permanent") {
      localStorage.removeItem(this.getStorageKey());
      this.hidePopup();
    } else {
      this.hidePopup();
    }
    return false;
  }

  isPopupDismissed(dismissedDate = localStorage.getItem(this.getStorageKey())) {
    if (this.isAdminEditor) return false;

    if (dismissedDate === "permanent") return true;
    if (!dismissedDate || !this.delayTime) return false;

    const today = new Date().toDateString();
    const lastDismissed = new Date(dismissedDate).toDateString();
    const daysPassed = Math.floor(
      (new Date(today) - new Date(lastDismissed)) / (1000 * 60 * 60 * 24)
    );

    return daysPassed < this.delayTime;
  }

  handleOverlay() {
    if (!this.isAdminEditor) {
      if (this.enabledOverlay == "true") {
        document.body.classList.add("o-hidden");
      } else {
        document.body.classList.remove("o-hidden");
      }
      const allPopups = BUTHelper.qsa(".js-but-popup");
      allPopups.forEach((popup) => {
        if (
          !popup.classList.contains("hidden-xs") &&
          popup.dataset.enabledOverlay == "true"
        )
          document.body.classList.add("o-hidden");
      });
    }
  }
  updateZIndex() {
    BUTPopup.currentZIndex += 2;
    this.querySelector(".js-popup-container").style.zIndex =
      BUTPopup.currentZIndex.toString();
  }

  handleClose() {
    this.hidePopup();

    if (!this.isAdminEditor) {
      if (this.delayTime > 0) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        localStorage.setItem(this.getStorageKey(), today.toString());
      } else {
        localStorage.setItem(this.getStorageKey(), "permanent");
      }
    }
  }

  hidePopup() {
    let fallback;
    const onAnimationEnd = (event) => {
      // Ignore animations bubbling up from inside the popup (image, buttons)
      if (event.animationName === "popupOut") finish();
    };
    const finish = () => {
      clearTimeout(fallback);
      this.container?.removeEventListener("animationend", onAnimationEnd);
      this.classList.remove("is-active", "drawer-out");
      this.classList.add("hidden-xs");
      document.body.classList.remove("o-hidden");
      const allPopups = BUTHelper.qsa(".js-but-popup");
      allPopups.forEach((popup) => {
        if (
          !popup.classList.contains("hidden-xs") &&
          popup.dataset.enabledOverlay == "true"
        )
          document.body.classList.add("o-hidden");
      });
    };

    // Already hidden (e.g. the state check on page load): nothing to animate
    if (!this.classList.contains("is-active")) {
      finish();
      return;
    }

    // Hide when the close animation actually ends; the timeout only covers
    // browsers that skip animationend (reduced motion, background tab)
    fallback = setTimeout(finish, 400);
    this.container?.addEventListener("animationend", onAnimationEnd);
    this.classList.add("drawer-out");
  }

  // The popup sits off-screen until it opens, so its lazy image would only
  // start loading - and decode - in the middle of the entrance animation
  preloadImages() {
    this.$$("img").forEach((img) => {
      img.loading = "eager";
    });
  }

  decodeImages() {
    const decodes = Array.from(this.$$("img"), (img) =>
      img.decode ? img.decode().catch(() => {}) : Promise.resolve()
    );
    // Never hold the popup back for long on a slow connection
    const timeout = new Promise((resolve) => setTimeout(resolve, 1500));
    return Promise.race([Promise.all(decodes), timeout]);
  }

  showPopup() {
    if (this.isAdminEditor) return;
    this.preloadImages();
    this.decodeImages().then(() => {
      this.handleOverlay();
      this.updateZIndex();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.remove("hidden-xs");
          this.classList.add("is-active");
        });
      });
    });
  }

  handlePopupInAdmin() {
    if (this.isAdminEditor) {
      document.addEventListener("shopify:section:select", (event) => {
        if (event.target.id.includes("popup")) {
          const popup = event.target.querySelector(".popup");
          setTimeout(() => {
            popup.classList.remove("hidden-xs");
            popup.classList.add("is-active");
            if (popup.dataset.enabledOverlay == "true") {
              document.body.classList.add("o-hidden");
            } else {
              document.body.classList.remove("o-hidden");
            }
          }, 300);
        }
      });
      document.addEventListener("shopify:section:deselect", (event) => {
        if (event.target.id.includes("popup")) this.hidePopup();
      });
    }
  }
}

window.BUTPopupComponent = window.BUTPopupComponent || class BUTPopupComponent extends BUTPopup {
  constructor() {
    super();
    this.delayUntil = parseInt(this.dataset.delayUntil);
    this.initDelayUntil();
  }

  initDelayUntil() {
    if (this.isPopupDismissed()) {
      return;
    }
    // Start fetching the image during the delay, not when the popup opens
    this.preloadImages();

    if (this.delayUntil === 0) {
      this.showPopup(this);
      BUTHelper.trapFocus(this.$(".js-popup-btn-close"));
    } else if (this.delayUntil > 0) {
      setTimeout(() => {
        if (!this.isPopupDismissed()) {
          this.showPopup(this);
          BUTHelper.trapFocus(this.$(".js-popup-btn-close"));
        }
      }, this.delayUntil * 1000);
    }
  }
}

if (!customElements.get("but-popup-component")) {
  customElements.define("but-popup-component", window.BUTPopupComponent);
}